module.exports = __webpack_public_path__ + "img/consortium.7454d330.jpg";